import { Button, Form, Select, notification } from 'antd';
import { useTranslation } from 'react-i18next';

import {
    DeleteOutlined,
    PaperClipOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import GlobalService from '../../../services/Global.service';
import RopaService from '../../../services/Ropa.service';
import { createRef, useState } from 'react';
import ModalFail from '../../../components/Shared/modal/fail';

const ModalActivityTab2 = ({
    search,
    handelClose,
    departmentList,
    setOpenSuccess,
    form2,
    isRoleAdmin,
    setValidateFile,
    validateFile,
    files,
    setFiles,
}) => {
    const { t } = useTranslation();

    const [msg, setMsg] = useState('');
    const [openFail, setOpenFail] = useState(false);
    const [loadingImport, setLoadingImport] = useState(false);
    const ref = createRef();

    const allowedType = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    ];

    const onChange = async (e) => {
        if (
            e.target.files.length &&
            e.target.files.length + files.length <= 10
        ) {
            console.log(e);
            for (let i = 0; i < e.target.files.length; i++) {
                const fileSize = e.target.files[i].size / 1024 / 1024;
                const fileType = e.target.files[i].type;
                if (fileSize >= 2) {
                    notification['error']({
                        message: t('fileHinTitle'),
                    });
                    return;
                }
                if (!allowedType.includes(fileType)) {
                    setMsg(t('importActivity.importType'));
                    setOpenFail(true);
                    return;
                }
            }
            let listFile = [...files];
            for (let i = 0; i < e.target.files.length; i++) {
                listFile.push(e.target.files[i]);
            }
            setFiles([...listFile]);
            form2.setFieldsValue({
                file: listFile,
            });
            if (listFile?.length <= 0) {
                setValidateFile(true);
                form2.setFields([
                    {
                        name: 'file',
                        errors: [t('errorText.requiredField')],
                    },
                ]);
            } else {
                setValidateFile(false);
            }
        }
    };

    const onInputClick = (event) => {
        event.target.value = '';
    };

    const downloadDoc = (file) => {
        GlobalService.downloadDoc(file?.fileStorageId).then((res) => {
            if (res.data) {
                const objectURL = URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = file?.fileName;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
        });
    };

    const clearForm2 = () => {
        form2.resetFields();
    };

    const dawnloadTemplete = async () => {
        await RopaService.dawnloadTemplete()
            .then((res) => {
                const objectURL = URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = `Template Import Activity.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const onSubmitForm2 = async (e) => {
        setLoadingImport(true);
        let bodyFormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            console.log(files[i]);
            bodyFormData.append('file', files[i]);
        }
        bodyFormData.append('departmentId', e.departmentId);
        console.log(bodyFormData);
        await RopaService.importActivity(bodyFormData)
            .then((res) => {
                setLoadingImport(false);
                setOpenSuccess(true);
                setTimeout(() => {
                    search();
                    handelClose();
                }, 1800);
            })
            .catch((err) => {
                search();
                handelClose();
                setLoadingImport(false);
                console.log(err?.data?.errorData?.msg);
                const text = err?.data?.errorData?.msg;

                if (text?.indexOf('IS EXIST IN BUSINESS_NAME') > 0) {
                    setMsg(t('importActivity.activityExist'));
                    setOpenFail(true);
                }
                if (text?.indexOf('NOT FOUND') > 0) {
                    setMsg(t('importActivity.notFound'));
                    setOpenFail(true);
                }
                if (text?.indexOf('REVIEWED') > 0) {
                    setMsg(t('importActivity.notReviewed'));
                    setOpenFail(true);
                }
                if (text === 'ERROR ROPA IMPORT BUSINESS_NAME IS EMPTY') {
                    setMsg(t('importActivity.businessNameIsEmpty'));
                    setOpenFail(true);
                }
                if (text === 'ERROR ROPA IMPORT FILE IS EMPTY') {
                    setMsg(t('importActivity.notFound'));
                    setOpenFail(true);
                }
                if (text === 'ERROR ROPA IMPORT FILE FORMAT IS WRONG') {
                    setMsg(t('importActivity.notFound'));
                    setOpenFail(true);
                }
                if (text === 'ERROR ROPA IMPORT ACTIVITY_NAME IS DUPLICATE') {
                    setMsg(t('importActivity.activityNameIsDuplicate'));
                    setOpenFail(true);
                }
            });
    };

    const checkFile = () => {
        if (files && files.length > 0) {
            console.log('false');
            setValidateFile(false);
            return Promise.resolve();
        }
        console.log('true');
        setValidateFile(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    return (
        <Form form={form2} layout="vertical" onFinish={onSubmitForm2}>
            <Form.Item
                name="departmentId"
                label={t('Department')}
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <Select
                    size="large"
                    disabled={!isRoleAdmin}
                    placeholder={t('Select Department')}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        (option?.children ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                >
                    {departmentList.map((e) => {
                        return (
                            <Select key={e.id} value={e.id}>
                                {e.value}
                            </Select>
                        );
                    })}
                </Select>
            </Form.Item>
            <Form.Item label={t('RoPA.DownloadTempleteImportFile')}>
                <Button
                    size="large"
                    className="border-solid border hover:text-black hover:opacity-100 rounded-lg flex space-x-3 font-semibold"
                    onClick={() => dawnloadTemplete()}
                >
                    <div className="">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M24.2188 21.0938H13.2812C12.85 21.0938 12.5 20.7438 12.5 20.3125C12.5 19.8813 12.5 5.11875 12.5 4.6875C12.5 4.25625 12.85 3.90625 13.2812 3.90625H24.2188C24.65 3.90625 25 4.25625 25 4.6875V20.3125C25 20.7438 24.65 21.0938 24.2188 21.0938Z"
                                fill="#ECEFF1"
                            />
                            <path
                                d="M16.4062 8.59473H13.2812C12.85 8.59473 12.5 8.24473 12.5 7.81348C12.5 7.38223 12.85 7.03223 13.2812 7.03223H16.4062C16.8375 7.03223 17.1875 7.38223 17.1875 7.81348C17.1875 8.24473 16.8375 8.59473 16.4062 8.59473Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M16.4062 11.7197H13.2812C12.85 11.7197 12.5 11.3697 12.5 10.9385C12.5 10.5072 12.85 10.1572 13.2812 10.1572H16.4062C16.8375 10.1572 17.1875 10.5072 17.1875 10.9385C17.1875 11.3697 16.8375 11.7197 16.4062 11.7197Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M16.4062 14.8447H13.2812C12.85 14.8447 12.5 14.4947 12.5 14.0635C12.5 13.6322 12.85 13.2822 13.2812 13.2822H16.4062C16.8375 13.2822 17.1875 13.6322 17.1875 14.0635C17.1875 14.4947 16.8375 14.8447 16.4062 14.8447Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M16.4062 17.9697H13.2812C12.85 17.9697 12.5 17.6197 12.5 17.1885C12.5 16.7572 12.85 16.4072 13.2812 16.4072H16.4062C16.8375 16.4072 17.1875 16.7572 17.1875 17.1885C17.1875 17.6197 16.8375 17.9697 16.4062 17.9697Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M21.0938 8.59473H19.5312C19.1 8.59473 18.75 8.24473 18.75 7.81348C18.75 7.38223 19.1 7.03223 19.5312 7.03223H21.0938C21.525 7.03223 21.875 7.38223 21.875 7.81348C21.875 8.24473 21.525 8.59473 21.0938 8.59473Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M21.0938 11.7197H19.5312C19.1 11.7197 18.75 11.3697 18.75 10.9385C18.75 10.5072 19.1 10.1572 19.5312 10.1572H21.0938C21.525 10.1572 21.875 10.5072 21.875 10.9385C21.875 11.3697 21.525 11.7197 21.0938 11.7197Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M21.0938 14.8447H19.5312C19.1 14.8447 18.75 14.4947 18.75 14.0635C18.75 13.6322 19.1 13.2822 19.5312 13.2822H21.0938C21.525 13.2822 21.875 13.6322 21.875 14.0635C21.875 14.4947 21.525 14.8447 21.0938 14.8447Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M21.0938 17.9697H19.5312C19.1 17.9697 18.75 17.6197 18.75 17.1885C18.75 16.7572 19.1 16.4072 19.5312 16.4072H21.0938C21.525 16.4072 21.875 16.7572 21.875 17.1885C21.875 17.6197 21.525 17.9697 21.0938 17.9697Z"
                                fill="#388E3C"
                            />
                            <path
                                d="M13.7797 0.96199C13.6016 0.813553 13.3625 0.74949 13.1375 0.796365L0.6375 3.14012C0.267187 3.20887 0 3.53074 0 3.9073V21.0948C0 21.4698 0.267187 21.7932 0.6375 21.862L13.1375 24.2057C13.1844 24.2151 13.2328 24.2198 13.2812 24.2198C13.4625 24.2198 13.6391 24.1573 13.7797 24.0401C13.9594 23.8917 14.0625 23.6698 14.0625 23.4386V1.56355C14.0625 1.33074 13.9594 1.11043 13.7797 0.96199Z"
                                fill="#2E7D32"
                            />
                            <path
                                d="M10.7436 15.1112L8.27326 12.2877L10.7717 9.07522C11.0373 8.73459 10.9748 8.24397 10.6358 7.97834C10.2967 7.71272 9.80608 7.77522 9.53889 8.11428L7.22483 11.0893L5.27483 8.86116C4.98889 8.53303 4.49514 8.50334 4.17326 8.78772C3.84826 9.07209 3.81545 9.56584 4.09983 9.88928L6.24826 12.3455L4.07014 15.1455C3.80451 15.4862 3.86701 15.9768 4.20608 16.2424C4.34983 16.3533 4.52014 16.4065 4.68733 16.4065C4.92014 16.4065 5.14983 16.3033 5.30451 16.1049L7.2967 13.5424L9.56858 16.1377C9.72326 16.3158 9.93889 16.4065 10.1561 16.4065C10.3389 16.4065 10.5217 16.3424 10.6701 16.2127C10.9951 15.9283 11.028 15.4346 10.7436 15.1112Z"
                                fill="#FAFAFA"
                            />
                        </svg>
                    </div>
                    <div className="">
                        <span className="inline-block align-middle">
                            Template Import Activity.xlsx
                        </span>
                    </div>
                    <div className="">
                        <span className="inline-block align-middle mt-1">
                            <svg
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.66699 8.28325L8.82899 6.12192L9.77166 7.06459L6.00033 10.8359L2.22899 7.06459L3.17166 6.12192L5.33366 8.28325V0.833252H6.66699V8.28325ZM0.666992 10.1666H2.00033V12.8333H10.0003V10.1666H11.3337V12.8333C11.3337 13.5666 10.7337 14.1666 10.0003 14.1666H2.00033C1.26699 14.1666 0.666992 13.5246 0.666992 12.8333V10.1666Z"
                                    fill="#171717"
                                />
                            </svg>
                        </span>
                    </div>
                </Button>
            </Form.Item>
            <Form.Item
                label={t('RoPA.ImportFileActivity')}
                extra={t('RoPA.ImportExtra')}
                name="file"
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                        validator: checkFile,
                    },
                ]}
            >
                <div
                    className={`border-solid border ${
                        validateFile ? 'border-red-400' : 'border-blue-400'
                    } rounded-md min-h-[112px] px-2`}
                >
                    <label
                        onClick={() => ref.current.click()}
                        className={'cursor-pointer'}
                    >
                        <Button
                            className={`mt-2 border-dashed border ${
                                validateFile
                                    ? 'border-red-400 text-red-600'
                                    : 'border-sky-300 text-sky-500'
                            }   bg-sky-50 mb-2`}
                            icon={<PlusCircleOutlined />}
                        >
                            {t('choose file')}
                        </Button>
                        <input
                            ref={ref}
                            disabled={files.length === 10}
                            onChange={onChange}
                            onClick={onInputClick}
                            type="file"
                            style={{ display: 'none' }}
                            multiple
                            accept={allowedType.join(',')}
                            // value={valueInput}
                        />
                    </label>
                    <div className="pb-2">
                        {files?.map((file, i) => {
                            return (
                                <div className="flex justify-between">
                                    <div
                                        key={i}
                                        className="text-new space-x-2 cursor-pointer"
                                        onClick={() => downloadDoc(file)}
                                    >
                                        <PaperClipOutlined />
                                        <span>{file.name}</span>
                                    </div>
                                    <div
                                        onClick={() => {
                                            setFiles(
                                                files.filter(
                                                    (data, key) => key !== i
                                                )
                                            );
                                            const listFile = files.filter(
                                                (data, key) => key !== i
                                            );
                                            form2.setFieldsValue({
                                                file: listFile,
                                            });
                                        }}
                                        className="text-[#95A0A8] cursor-pointer"
                                    >
                                        <DeleteOutlined />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Form.Item>
            <div className="flex justify-center items-center space-x-4 pt-12">
                <Button
                    type="primary"
                    onClick={() => {
                        handelClose();
                        clearForm2();
                    }}
                    size="large"
                    ghost
                >
                    {t('common.Cancel')}
                </Button>
                <Button
                    loading={loadingImport}
                    htmlType="submit"
                    size="large"
                    type="primary"
                >
                    {t('common.Submit')}
                </Button>
            </div>
            <ModalFail
                text={msg}
                title={t('importActivity.importActivityFail')}
                open={openFail}
                handelClose={() => setOpenFail(false)}
            />
        </Form>
    );
};
export default ModalActivityTab2;
